import { i18nextContainer } from 'shared/configs/i18n/config'
import { AppGroup } from 'shared/constants/apps'
import { AppConfig } from 'shared/types/app'

export type AppGroupData = { [K in AppGroup]?: AppConfig[] }

export const getTypedGroupEntries = (
  groupData: AppGroupData
): Array<[AppGroup, AppConfig[]]> => {
  return (Object.keys(groupData) as AppGroup[])
    .filter((key): key is AppGroup =>
      Object.values(AppGroup).includes(key as AppGroup)
    )
    .map(key => [key, groupData[key]!] as [AppGroup, AppConfig[]])
}

export const getGroupLabel = (groupKey: string): string => {
  switch (groupKey) {
    case AppGroup.WORKFORCE_MANAGEMENT:
      return i18nextContainer.t('launchpad.groups.workforce_management')
    case AppGroup.OFFICE_TOOLS:
      return i18nextContainer.t('launchpad.groups.office_tools')
    case AppGroup.COMMUNICATION:
      return i18nextContainer.t('launchpad.groups.communication')
    case AppGroup.BUSINESS_TOOLS:
      return i18nextContainer.t('launchpad.groups.business_tools')
    case AppGroup.CONFIGURATION:
      return i18nextContainer.t('launchpad.groups.configuration')
    default:
      return groupKey
  }
}
